import logo from "../utilities/images/syncfonia.png";
import logoWhite from "../utilities/images/syncfonia-white.png";
import gs1mx from "../utilities/images/gs1mx.png";

const lookAndFeel = {
  "logo": {
    "src": logo,
    "gs1": gs1mx
  },
  "progressbar": "#0A2C6C",
  "navbar": {
    "logo": logoWhite,
    "shadow": false,
    "solid": "#0A2C6C",
    "text": "#ffffff"
  },
  "regular": {
    "text": "#000000"
  },
  "primary": {
    "solid": "#F26334",
    "text": "#ffffff"
  },
  "secondary": {
    "solid": "#0A2C6C"
  },
  "success": {
    "solid": "",
    "text": ""
  },
  "error": {
    "solid": "",
    "text": ""
  },
  "warning": {
    "solid": "",
    "text": ""
  },
  "requestAccess": "https://webapp.gs1mexico.org/dynamicforms/register/emailsentnotification"
};

export default lookAndFeel;
